 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"about":"about","admin-class-detail~camp-learning~clock-in-detail-long":"admin-class-detail~camp-learning~clock-in-detail-long","camp-learning~camp-play":"camp-learning~camp-play","camp-learning":"camp-learning","admin-class-detail":"admin-class-detail","admin-class-list":"admin-class-list","admin-comment~clock-in~clock-in-detail~clock-in-detail-long~clock-in-theme~my-clock-in":"admin-comment~clock-in~clock-in-detail~clock-in-detail-long~clock-in-theme~my-clock-in","admin-comment~clock-in-detail~clock-in-detail-long~clock-in-theme~my-clock-in":"admin-comment~clock-in-detail~clock-in-detail-long~clock-in-theme~my-clock-in","clock-in-detail-long":"clock-in-detail-long","admin-comment~clock-in~clock-in-detail~clock-in-theme~my-clock-in":"admin-comment~clock-in~clock-in-detail~clock-in-theme~my-clock-in","admin-comment":"admin-comment","clock-in-detail~clock-in-theme":"clock-in-detail~clock-in-theme","clock-in-detail":"clock-in-detail","clock-in-theme":"clock-in-theme","my-clock-in":"my-clock-in","clock-in":"clock-in","agreement":"agreement","article":"article","attention":"attention","camp":"camp","camp-play":"camp-play","category":"category","content~recommend":"content~recommend","content":"content","recommend":"recommend","discuss":"discuss","distribut-instructions":"distribut-instructions","download":"download","explain":"explain","explain-for-coin":"explain-for-coin","fans":"fans","home":"home","invite":"invite","login":"login","lottery":"lottery","not-found":"not-found","privacy-policy":"privacy-policy","privacy-policy-new":"privacy-policy-new","protocol":"protocol","topic":"topic","user":"user"}[chunkId]||chunkId) + "." + {"about":"a1c7efdd","admin-class-detail~camp-learning~clock-in-detail-long":"8b26df98","camp-learning~camp-play":"7b767846","camp-learning":"c4fab573","chunk-a80afa8c":"4f109c3c","admin-class-detail":"e6b33d41","admin-class-list":"684aa670","admin-comment~clock-in~clock-in-detail~clock-in-detail-long~clock-in-theme~my-clock-in":"fc3663c1","admin-comment~clock-in-detail~clock-in-detail-long~clock-in-theme~my-clock-in":"a075d89d","clock-in-detail-long":"c33b7501","admin-comment~clock-in~clock-in-detail~clock-in-theme~my-clock-in":"5ebe3043","admin-comment":"a318155d","clock-in-detail~clock-in-theme":"7969a25f","clock-in-detail":"ab116281","clock-in-theme":"f4573ca4","my-clock-in":"ab084854","chunk-51b8e7a8":"bb8dbdc5","clock-in":"db3a93ed","agreement":"96047758","article":"60319b9d","attention":"9f38c86b","camp":"6650515e","camp-play":"00a29fab","category":"3384fb8a","chunk-032b211c":"ffcfab5b","chunk-33bc09f8":"28d0aec5","chunk-410a3987":"e299c9d6","chunk-4478c52e":"770eb1b2","chunk-00154645":"29857e46","chunk-3755cb19":"6a9dc13b","chunk-e424ea78":"6a1cbb9b","chunk-7851c888":"9a4a9b31","chunk-2c8f86dc":"eccb965a","content~recommend":"dcf4d815","content":"7e0f0da0","recommend":"163ae537","discuss":"db312145","distribut-instructions":"075eac0c","download":"8bef6c47","explain":"425150d1","explain-for-coin":"8f833e36","fans":"02dda2f2","home":"c4516783","invite":"37f7b51f","login":"97560c8b","lottery":"7cf5aa08","not-found":"51e609e2","privacy-policy":"9e3680ee","privacy-policy-new":"dd7deb25","protocol":"8ed96215","topic":"7d87d2a7","user":"30f94069"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"about":1,"camp-learning~camp-play":1,"camp-learning":1,"admin-class-detail":1,"admin-class-list":1,"admin-comment~clock-in~clock-in-detail~clock-in-detail-long~clock-in-theme~my-clock-in":1,"admin-comment~clock-in-detail~clock-in-detail-long~clock-in-theme~my-clock-in":1,"clock-in-detail-long":1,"admin-comment~clock-in~clock-in-detail~clock-in-theme~my-clock-in":1,"admin-comment":1,"clock-in-detail~clock-in-theme":1,"clock-in-detail":1,"clock-in-theme":1,"my-clock-in":1,"chunk-51b8e7a8":1,"clock-in":1,"agreement":1,"article":1,"attention":1,"camp":1,"camp-play":1,"category":1,"chunk-032b211c":1,"chunk-33bc09f8":1,"chunk-410a3987":1,"chunk-4478c52e":1,"chunk-00154645":1,"chunk-3755cb19":1,"chunk-e424ea78":1,"chunk-7851c888":1,"chunk-2c8f86dc":1,"content~recommend":1,"content":1,"recommend":1,"discuss":1,"distribut-instructions":1,"download":1,"explain":1,"explain-for-coin":1,"fans":1,"home":1,"invite":1,"login":1,"lottery":1,"not-found":1,"privacy-policy":1,"privacy-policy-new":1,"protocol":1,"topic":1,"user":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"about":"about","admin-class-detail~camp-learning~clock-in-detail-long":"admin-class-detail~camp-learning~clock-in-detail-long","camp-learning~camp-play":"camp-learning~camp-play","camp-learning":"camp-learning","admin-class-detail":"admin-class-detail","admin-class-list":"admin-class-list","admin-comment~clock-in~clock-in-detail~clock-in-detail-long~clock-in-theme~my-clock-in":"admin-comment~clock-in~clock-in-detail~clock-in-detail-long~clock-in-theme~my-clock-in","admin-comment~clock-in-detail~clock-in-detail-long~clock-in-theme~my-clock-in":"admin-comment~clock-in-detail~clock-in-detail-long~clock-in-theme~my-clock-in","clock-in-detail-long":"clock-in-detail-long","admin-comment~clock-in~clock-in-detail~clock-in-theme~my-clock-in":"admin-comment~clock-in~clock-in-detail~clock-in-theme~my-clock-in","admin-comment":"admin-comment","clock-in-detail~clock-in-theme":"clock-in-detail~clock-in-theme","clock-in-detail":"clock-in-detail","clock-in-theme":"clock-in-theme","my-clock-in":"my-clock-in","clock-in":"clock-in","agreement":"agreement","article":"article","attention":"attention","camp":"camp","camp-play":"camp-play","category":"category","content~recommend":"content~recommend","content":"content","recommend":"recommend","discuss":"discuss","distribut-instructions":"distribut-instructions","download":"download","explain":"explain","explain-for-coin":"explain-for-coin","fans":"fans","home":"home","invite":"invite","login":"login","lottery":"lottery","not-found":"not-found","privacy-policy":"privacy-policy","privacy-policy-new":"privacy-policy-new","protocol":"protocol","topic":"topic","user":"user"}[chunkId]||chunkId) + "." + {"about":"96772e39","admin-class-detail~camp-learning~clock-in-detail-long":"31d6cfe0","camp-learning~camp-play":"bed26036","camp-learning":"5412f170","chunk-a80afa8c":"31d6cfe0","admin-class-detail":"4256be6a","admin-class-list":"041a4192","admin-comment~clock-in~clock-in-detail~clock-in-detail-long~clock-in-theme~my-clock-in":"fc1649da","admin-comment~clock-in-detail~clock-in-detail-long~clock-in-theme~my-clock-in":"68529dc3","clock-in-detail-long":"665287f1","admin-comment~clock-in~clock-in-detail~clock-in-theme~my-clock-in":"c34e15f9","admin-comment":"86d3127d","clock-in-detail~clock-in-theme":"0f2466b1","clock-in-detail":"e8b3f887","clock-in-theme":"a158a5ea","my-clock-in":"7114fe5b","chunk-51b8e7a8":"bed26036","clock-in":"21aa3398","agreement":"577b98c3","article":"eb021243","attention":"443b08be","camp":"9c016050","camp-play":"bbf38fed","category":"af50bca5","chunk-032b211c":"ca4c8689","chunk-33bc09f8":"e2e2c202","chunk-410a3987":"74bfa459","chunk-4478c52e":"03006cb8","chunk-00154645":"54a4151a","chunk-3755cb19":"4e9e5090","chunk-e424ea78":"b44f5d02","chunk-7851c888":"2a846dee","chunk-2c8f86dc":"86ceab88","content~recommend":"8e87d68f","content":"7583cd4e","recommend":"a7e1187a","discuss":"13b9c7a5","distribut-instructions":"38c89653","download":"8d20022b","explain":"38c89653","explain-for-coin":"38c89653","fans":"d03959bf","home":"399ef695","invite":"6b005c57","login":"7969bdbe","lottery":"456d5623","not-found":"7b0ade42","privacy-policy":"9accb88b","privacy-policy-new":"7e844dc0","protocol":"b7e477c1","topic":"ad2f3c2e","user":"fb6275be"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "//alcdn.yojiang.cn/front_static/servers/classroom/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
